import { ScanTransformation } from "types/scan";

export const IDENTITY_MATRIX = [
  [1, 0, 0, 0],
  [0, 1, 0, 0],
  [0, 0, 1, 0],
  [0, 0, 0, 1],
] as const;

export const isScanTransformationDataValid = (scanTransformation: ScanTransformation | null | undefined) => {
  if (!scanTransformation) {
    return false;
  }
  
  if (scanTransformation.type === 'WRT_GT') {
    // may cause bugs, handle with care
    return true;
  }
  
  if (scanTransformation.type === 'WRT_FLOOR') {
    return !!scanTransformation.referenceFloorId;
  }
  
  if (scanTransformation.type === 'WRT_BIM') {
    return !!scanTransformation.referenceBIMId;
  }
  
  if (scanTransformation.type === 'WRT_SCAN') {
    return !!scanTransformation.referenceScanId;
  }
  
  return false;
}